import { render, staticRenderFns } from "./followReply.vue?vue&type=template&id=3e227fd7&scoped=true"
import script from "./followReply.vue?vue&type=script&lang=js"
export * from "./followReply.vue?vue&type=script&lang=js"
import style0 from "./followReply.vue?vue&type=style&index=0&id=3e227fd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e227fd7",
  null
  
)

export default component.exports